function bindEvents(props, VueEmit, instance) {
    for (const key of Object.keys(props)) {
        if (/^on/.test(key) && props[key]) {
            const _key = key.replace(/^on/, '').toLocaleLowerCase();
            instance.addEventListener(_key, (e) => {
                var _a, _b;
                e.preventDefault = e.preventDefault || ((_a = e.domEvent) === null || _a === void 0 ? void 0 : _a.preventDefault.bind(e.domEvent));
                e.stopPropagation = e.stopPropagation || ((_b = e.domEvent) === null || _b === void 0 ? void 0 : _b.stopPropagation.bind(e.domEvent));
                VueEmit(_key, e);
            });
        }
    }
}

export { bindEvents };
